var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 6.14679C12.1933 6.14679 11.7 5.29345 12.3 4.24679C12.6467 3.64012 12.44 2.86679 11.8333 2.52012L10.68 1.86012C10.1533 1.54679 9.47333 1.73345 9.16 2.26012L9.08667 2.38679C8.48667 3.43345 7.5 3.43345 6.89333 2.38679L6.82 2.26012C6.52 1.73345 5.84 1.54679 5.31333 1.86012L4.16 2.52012C3.55333 2.86679 3.34667 3.64679 3.69333 4.25345C4.3 5.29345 3.80667 6.14679 2.6 6.14679C1.90667 6.14679 1.33333 6.71345 1.33333 7.41345V8.58679C1.33333 9.28012 1.9 9.85345 2.6 9.85345C3.80667 9.85345 4.3 10.7068 3.69333 11.7535C3.34667 12.3601 3.55333 13.1335 4.16 13.4801L5.31333 14.1401C5.84 14.4535 6.52 14.2668 6.83333 13.7401L6.90667 13.6135C7.50667 12.5668 8.49333 12.5668 9.1 13.6135L9.17333 13.7401C9.48667 14.2668 10.1667 14.4535 10.6933 14.1401L11.8467 13.4801C12.4533 13.1335 12.66 12.3535 12.3133 11.7535C11.7067 10.7068 12.2 9.85345 13.4067 9.85345C14.1 9.85345 14.6733 9.28679 14.6733 8.58679V7.41345C14.6667 6.72012 14.1 6.14679 13.4 6.14679ZM8 10.1668C6.80667 10.1668 5.83333 9.19345 5.83333 8.00012C5.83333 6.80679 6.80667 5.83345 8 5.83345C9.19333 5.83345 10.1667 6.80679 10.1667 8.00012C10.1667 9.19345 9.19333 10.1668 8 10.1668Z",
    fill: "#717680"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting2);
export default __webpack_public_path__ + "static/media/setting-2.d84a2e876db6f4c2c39c730fe0b5a7cc.svg";
export { ForwardRef as ReactComponent };